// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"87ab1c3d","52":"dea6d953","68":"bdc083a6","88":"68d50131","112":"2dcc4425","172":"30132c59","182":"cdf2884d","308":"c54d50e3","320":"d3e149c9","626":"8b242e6a","630":"b997a6d9","696":"e6ef0bf9","768":"5428d6b1","776":"16b374a7","896":"eb08045f","928":"d7a9d2ba"}[chunkId] + ".chunk.js";
};